import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Lightbulb, Code, Users } from 'lucide-react';

const CompanyHero = () => {
  return (
    <section className="bg-gradient-to-br from-primary-50 via-white to-primary-50 py-20 min-h-screen flex items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-12">
          {/* Company Logo and Name */}
          <div className="space-y-6">
            <div className="flex justify-center">
              <img src="/logo.png" alt="Research and Innovation Studios" className="w-20 h-20" />
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
              Research and{' '}
              <span className="bg-gradient-to-r from-primary-500 to-primary-600 bg-clip-text text-transparent">
                Innovation Studios
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Pioneering innovative solutions through cutting-edge research and development. 
              We create transformative technologies that shape the future.
            </p>
          </div>

          {/* Key Values */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
                <Lightbulb className="w-8 h-8 text-primary-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Innovation</h3>
              <p className="text-gray-600 text-center">Pushing boundaries with creative solutions</p>
            </div>
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
                <Code className="w-8 h-8 text-primary-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Research</h3>
              <p className="text-gray-600 text-center">Deep analysis and evidence-based development</p>
            </div>
          </div>

          {/* Projects CTA Button */}
          <div className="pt-8">
            <Link 
              to="/bulk-leads-caller"
              className="inline-flex items-center space-x-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white px-12 py-6 rounded-lg hover:from-primary-600 hover:to-primary-700 transition-all duration-200 text-xl font-semibold shadow-lg hover:shadow-xl"
            >
              <span>View Our Projects</span>
              <ArrowRight className="w-6 h-6" />
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center items-center space-x-8 text-sm text-gray-500 pt-8">
            <div className="flex items-center space-x-2">
              <span>✓ Research-Driven</span>
            </div>
            <div className="flex items-center space-x-2">
              <span>✓ Innovation-Focused</span>
            </div>
            <div className="flex items-center space-x-2">
              <span>✓ Quality Assured</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyHero;
